@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

<!-- Status filter menu — single-select: picking a status replaces the current one,
     and re-picking it (or the chip's X) clears back to every payment. No "All" option. -->
<mat-menu #filterMenu="matMenu" class="filter-menu">
  @for (option of filterOptions; track option.status) {
    <button mat-menu-item class="filter-option" (click)="selectFilter(option.status)">
      <span [ngStyle]="{'width':'8px','height':'8px','border-radius':'50%','background-color': option.color,'display':'inline-block','margin-right':'8px','flex-shrink':'0'}"></span>
      {{ option.status | translate }} ({{ option.count }})
      @if (selectedStatus === option.status) {
        <ion-icon name="checkmark-outline" style="margin-left: 8px;" />
      }
    </button>
  }
</mat-menu>

@if (windowService.isDesktopRes) {
  <tidy-desktop-header [isLoading]="!loaded">
    <div class="wrappable-container">
      <tidy-text [header]="'Rent Collection'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search payments'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Filter'"
        [image]="'assets/img/filter-white.svg'"
        [matMenuTriggerFor]="filterMenu" />
      @if (activeFilter) {
        <ion-chip class="filter-chip">
          <span [ngStyle]="{'width':'8px','height':'8px','border-radius':'50%','background-color': activeFilter.color,'display':'inline-block','margin-right':'6px','flex-shrink':'0'}"></span>
          <ion-label>{{ activeFilter.status | translate }}</ion-label>
          <ion-icon name="close-circle" (click)="clearFilter()" />
        </ion-chip>
      }
      <tidy-small-button
        [text]="'Request a Payment'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="requestPayment()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <tidy-image
        [src]="'assets/img/gear.svg'"
        class="desktop-header-icon secondary-text-icon"
        (action)="goToSettings()" />
      <automations-preview-button
        [tag]="'rent-collection'" />
    </div>
  </tidy-desktop-header>
}

@if (!loaded) {
  @for (i of [1,2,3,4,5]; track i) {
    <div style="width: 100%; margin-bottom: 6px;">
      <ion-skeleton-text animated="true" style="height: 44px; border-radius: 4px" />
    </div>
  }
}

@if (loaded) {

  @if (!windowService.isDesktopRes) {
    <div class="mobile-filter-row" style="margin-bottom: 10px;">
      <form [formGroup]="searchForm" novalidate action="#" style="flex: 1;">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search payments'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        class="mobile-filter-button"
        [iconOnly]="true"
        [image]="'assets/img/filter-white.svg'"
        [matMenuTriggerFor]="filterMenu" />
      <tidy-small-button
        class="mobile-filter-button"
        [iconOnly]="true"
        [image]="'assets/img/gear.svg'"
        (buttonClick)="goToSettings()" />
    </div>
    @if (activeFilter) {
      <div class="mobile-filter-chips" style="margin-bottom: 10px;">
        <ion-chip class="filter-chip">
          <span [ngStyle]="{'width':'8px','height':'8px','border-radius':'50%','background-color': activeFilter.color,'display':'inline-block','margin-right':'6px','flex-shrink':'0'}"></span>
          <ion-label>{{ activeFilter.status | translate }}</ion-label>
          <ion-icon name="close-circle" (click)="clearFilter()" />
        </ion-chip>
      </div>
    }
    <tidy-row class="extra-bottom-padding">
      <tidy-button [text]="'Request a Payment'" [action]="requestPaymentAction" class="primary" />
    </tidy-row>
  }

  @if (windowService.isDesktopRes) {
    @if (rows.length > 0) {
      <div class="desktop-flex-fill">
        <tidy-table
          #tidyTable
          [dataSource]="rows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [allRowIsClickable]="true"
          [rowsToShow]="50"
          [showColumnLines]="false"
          (cellClick)="onRowClick($event)"
          [blockSorting]="true" />
      </div>
    }
    @if (rows.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="emptyStateMessage" /></tidy-row></tidy-alert>
    }
  }

  @if (!windowService.isDesktopRes) {
    @for (view of shownPaymentViews; track view.payment.id) {
      <tidy-card (click)="onRowClick({ column: '', element: { id: view.payment.id } })">
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [header]="view.payment.payer_name" [translate]="false" />
          <tidy-text [body]="view.payment.status" [translate]="false" [ngStyle]="{ color: view.statusColor }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [helper]="view.payment.payer_type + ' · ' + view.propertyLabel" [translate]="false" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="view.payment.description" [translate]="false" />
          <tidy-text [body]="'$' + view.payment.amount.toLocaleString('en-US')" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/time-outline.svg'" class="body-size" />
          <tidy-text [helper]="(view.payment.status === 'Paid' ? 'Paid ' + (view.payment.paid_date | date:'MMM d') : 'Due ' + (view.payment.due_date | date:'MMM d')) + (view.payment.cadence === 'weekly' ? '  ·  Weekly' : '')" [translate]="false" />
        </tidy-row>
        @if (view.leaseLabel) {
          <tidy-row class="vertical-align-center">
            <tidy-text [actionBody]="view.leaseLabel" [translate]="false" (action)="goToLease(view.payment.lease_id)" class="white-link" />
          </tidy-row>
        }
      </tidy-card>
    }
    @if (shownPaymentViews.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="emptyStateMessage" /></tidy-row></tidy-alert>
    }
  }
}
